__turbopack_context__.v({
  "cards": "InitialWizard-module-scss-module__hKPzsa__cards",
  "container": "InitialWizard-module-scss-module__hKPzsa__container",
  "dialog": "InitialWizard-module-scss-module__hKPzsa__dialog",
  "footer": "InitialWizard-module-scss-module__hKPzsa__footer",
  "groupHeader": "InitialWizard-module-scss-module__hKPzsa__groupHeader",
  "selectButton": "InitialWizard-module-scss-module__hKPzsa__selectButton",
});
